import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EventResponse} from "../../../../shared/model/response/event/event-response.model";
import {EventUtilService} from "../../../../service/utils/event-util.service";

@Component({
    selector: 'app-eventcard',
    templateUrl: './eventcard.component.html',
    standalone: false
})
export class EventcardComponent implements OnInit, OnChanges {

  @Input("event") event : EventResponse;
  @Input("hyperlink") hyperLink : string;

  imageLoadFailed = false;

  constructor(private eventUtilService : EventUtilService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['event']) {
      this.imageLoadFailed = false;
    }
  }

  onImageError(): void {
    this.imageLoadFailed = true;
  }

  displayEventImage(): string {
    return this.eventUtilService.displayEventImage(this.event);
  }

}
